module.exports = __webpack_public_path__ + "6c4a0dbc/img/print-icon.d8dbbca5.svg";